var _AsyncWrapper_callback, _AsyncWrapper_completeEvent, _AsyncWrapper_promise, _AsyncWrapper_complete, _AsyncWrapper_success, _AsyncWrapper_error, _AsyncWrapper_value, _AsyncWrapper_promiseOrValueOrFactory, _AsyncWrapper_awaitable;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import SingleInvokeEvent from "../Events/SingleInvokeEvent";
import isFunction from '../TypeHelpers/isFunction';
import isUndefinedOrNull from '../TypeHelpers/isUndefinedOrNull';
/**
 * The AsyncWrapper is provided to monitor the state of a promise.
 * You can use this to provide state feedback to the user of an awaitable
 * method.
 */
export default class AsyncWrapper {
    constructor(promiseOrValueOrFactory, callback) {
        _AsyncWrapper_callback.set(this, void 0);
        _AsyncWrapper_completeEvent.set(this, void 0);
        _AsyncWrapper_promise.set(this, void 0);
        _AsyncWrapper_complete.set(this, void 0);
        _AsyncWrapper_success.set(this, void 0);
        _AsyncWrapper_error.set(this, void 0);
        _AsyncWrapper_value.set(this, void 0);
        _AsyncWrapper_promiseOrValueOrFactory.set(this, void 0);
        _AsyncWrapper_awaitable.set(this, void 0);
        __classPrivateFieldSet(this, _AsyncWrapper_awaitable, (async () => undefined)(), "f");
        __classPrivateFieldSet(this, _AsyncWrapper_complete, false, "f");
        __classPrivateFieldSet(this, _AsyncWrapper_success, false, "f");
        __classPrivateFieldSet(this, _AsyncWrapper_completeEvent, new SingleInvokeEvent(), "f");
        __classPrivateFieldSet(this, _AsyncWrapper_callback, callback, "f");
        __classPrivateFieldSet(this, _AsyncWrapper_promiseOrValueOrFactory, promiseOrValueOrFactory, "f");
        this.update(__classPrivateFieldGet(this, _AsyncWrapper_promiseOrValueOrFactory, "f"));
    }
    update(promiseOrValueOrFactory = __classPrivateFieldGet(this, _AsyncWrapper_promiseOrValueOrFactory, "f")) {
        if (promiseOrValueOrFactory !== undefined) {
            __classPrivateFieldSet(this, _AsyncWrapper_promiseOrValueOrFactory, promiseOrValueOrFactory, "f");
            __classPrivateFieldSet(this, _AsyncWrapper_success, false, "f");
            __classPrivateFieldSet(this, _AsyncWrapper_complete, false, "f");
            if (isFunction(__classPrivateFieldGet(this, _AsyncWrapper_promiseOrValueOrFactory, "f"))) {
                __classPrivateFieldSet(this, _AsyncWrapper_promise, Promise.resolve(__classPrivateFieldGet(this, _AsyncWrapper_promiseOrValueOrFactory, "f").call(this)), "f");
            }
            else {
                __classPrivateFieldSet(this, _AsyncWrapper_promise, Promise.resolve(__classPrivateFieldGet(this, _AsyncWrapper_promiseOrValueOrFactory, "f")), "f");
            }
            __classPrivateFieldSet(this, _AsyncWrapper_awaitable, new Promise((resolve, reject) => {
                (async () => {
                    let cancelled = false;
                    const promise = __classPrivateFieldGet(this, _AsyncWrapper_promise, "f");
                    try {
                        const value = await promise;
                        if (__classPrivateFieldGet(this, _AsyncWrapper_promise, "f") !== promise) {
                            cancelled = true;
                            return;
                        }
                        __classPrivateFieldSet(this, _AsyncWrapper_value, value, "f");
                        resolve(value);
                        __classPrivateFieldSet(this, _AsyncWrapper_success, true, "f");
                    }
                    catch (error) {
                        if (__classPrivateFieldGet(this, _AsyncWrapper_promise, "f") !== promise) {
                            cancelled = true;
                            return;
                        }
                        __classPrivateFieldSet(this, _AsyncWrapper_error, error, "f");
                        reject(error);
                        __classPrivateFieldSet(this, _AsyncWrapper_success, false, "f");
                    }
                    finally {
                        if (!cancelled) {
                            __classPrivateFieldSet(this, _AsyncWrapper_complete, true, "f");
                            __classPrivateFieldGet(this, _AsyncWrapper_completeEvent, "f").invoke(this, __classPrivateFieldGet(this, _AsyncWrapper_value, "f"));
                            if (!isUndefinedOrNull(__classPrivateFieldGet(this, _AsyncWrapper_callback, "f"))) {
                                __classPrivateFieldGet(this, _AsyncWrapper_callback, "f").call(this, this);
                            }
                        }
                    }
                })();
            }), "f");
        }
    }
    /** Event to be fired when the internal promise has completed */
    get completeEvent() {
        return __classPrivateFieldGet(this, _AsyncWrapper_completeEvent, "f");
    }
    /** Return the internal promise that is waiting for the orginal one to complete */
    get promise() {
        return __classPrivateFieldGet(this, _AsyncWrapper_awaitable, "f");
    }
    /** returns true when the promise is complete, even if it errored */
    get complete() {
        return __classPrivateFieldGet(this, _AsyncWrapper_complete, "f");
    }
    /** returns true if the promise completed successfully */
    get success() {
        return __classPrivateFieldGet(this, _AsyncWrapper_success, "f");
    }
    /** returns the value of the promise */
    get value() {
        return __classPrivateFieldGet(this, _AsyncWrapper_value, "f");
    }
    /** returns the error if the promise failed */
    get error() {
        return __classPrivateFieldGet(this, _AsyncWrapper_error, "f");
    }
    cancel() {
        __classPrivateFieldSet(this, _AsyncWrapper_promise, undefined, "f");
    }
}
_AsyncWrapper_callback = new WeakMap(), _AsyncWrapper_completeEvent = new WeakMap(), _AsyncWrapper_promise = new WeakMap(), _AsyncWrapper_complete = new WeakMap(), _AsyncWrapper_success = new WeakMap(), _AsyncWrapper_error = new WeakMap(), _AsyncWrapper_value = new WeakMap(), _AsyncWrapper_promiseOrValueOrFactory = new WeakMap(), _AsyncWrapper_awaitable = new WeakMap();
